import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';
import { SkeletonAdminList } from '../../components/Skeleton';

export default function AdminClinicians() {
  const [clinicians, setClinicians] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.admin.clinicians()
      .then(setClinicians)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl md:text-[32px] font-semibold text-text mb-1">Clinicians</h1>
        <p className="text-sm text-gray-500">This is a list of all clinicians in the database</p>
      </div>

      {loading ? (
        <SkeletonAdminList rows={8} showHeader={false} />
      ) : (
        <div className="bg-white rounded-xl border border-[#E6E6E6]">
          <div className="flex items-center px-4 md:px-5 py-3 border-b border-[#E6E6E6]">
            <span className="text-sm font-semibold text-gray-700 flex-1">Name</span>
            <span className="text-sm font-semibold text-gray-700 w-24 text-right">Status</span>
          </div>
          {clinicians.map((clinician, idx) => (
            <div
              key={clinician.id}
              className={`flex items-center px-4 md:px-5 py-3.5 ${
                idx !== clinicians.length - 1 ? 'border-b border-[#E6E6E6]' : ''
              }`}
            >
              <Link to={`/admin/clinicians/${clinician.id}`} className="text-sm font-medium text-primary hover:underline flex-1">{clinician.full_name}</Link>
              <span className={`text-xs font-medium px-2.5 py-1 rounded-full w-24 text-center ${
                clinician.active
                  ? 'bg-green-50 text-green-700'
                  : 'bg-red-50 text-destructive'
              }`}>
                {clinician.active ? 'Active' : 'Inactive'}
              </span>
            </div>
          ))}
          {clinicians.length === 0 && (
            <div className="px-5 py-8 text-center text-sm text-gray-500">No clinicians found</div>
          )}
        </div>
      )}
    </div>
  );
}
